import React, { useEffect, useMemo, useState } from 'react';
import { TouchableOpacity, View, Text, StyleSheet } from 'react-native';
import { FontAwesome5 } from '@expo/vector-icons';
import { Picker } from '@react-native-picker/picker';

import { getPlantationsData } from '../../../../api/AllAddress ';
import { BasicLayout, CommonContainer } from '../../../../common/components/CustomLayout';
import { BOHTBody, BOHTD, BOHTDIconBox, BOHTH2, BOHTHead, BOHTR, BOHTable } from '../../../../common/components/bohtable';
import { msgStr } from '../../../../common/constants/Message';
import { TextMediumSize } from '../../../../common/constants/Fonts';
import { useAlertModal } from '../../../../common/hooks';
import AddDeliveryChargeModal from './AddDeliveryChargeModal';

const DeliveryCharges = ({ navigation, goBack }) => {
  const { showAlert } = useAlertModal();
  
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [updateTrigger, setUpdateTrigger] = useState(true);
  const [isModalVisible, setModalVisible] = useState(false);
  const [selectedArea, setSelectedArea] = useState(null);
  const [filterBelongsTo, setFilterBelongsTo] = useState('');

  const InitialWidths = [150, 150, 120, 120, 80];

  useEffect(() => {
    if (updateTrigger) getTable();
  }, [updateTrigger, filterBelongsTo]);

  const getTable = () => {
    setIsLoading(true);
    getPlantationsData(filterBelongsTo, (jsonRes, status) => {
      switch (status) {
        case 200:
          setUpdateTrigger(false);
          setTableData(jsonRes || []);
          setIsLoading(false);
          break;
        case 500:
          showAlert('error', msgStr('serverError'));
          setIsLoading(false);
          break;
        default:
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          setIsLoading(false);
          break;
      }
    });
  };

  const openModal = (item) => {
    setSelectedArea(item);
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setSelectedArea(null);
  };

  const renderTableData = useMemo(() => {
    const rows = [];
    if (tableData.length > 0) {
      tableData.forEach((item, index) => {
        rows.push(
          <BOHTR key={item.id || index}>
            <BOHTD width={InitialWidths[0]}>{item.plantation}</BOHTD>
            <BOHTD width={InitialWidths[1]}>{item.belongs_to || '-'}</BOHTD>
            <BOHTD width={InitialWidths[2]}>${item.cr_delivery_charge || '0.00'}</BOHTD>
            <BOHTD width={InitialWidths[3]}>${item.partner_delivery_charge || '0.00'}</BOHTD>
            <BOHTDIconBox width={InitialWidths[4]}>
              <TouchableOpacity onPress={() => openModal(item)}>
                <FontAwesome5 size={TextMediumSize} name="edit" color="black" />
              </TouchableOpacity>
            </BOHTDIconBox>
          </BOHTR>
        );
      });
    }
    return <>{rows}</>;
  }, [tableData]);

  const tableElement = useMemo(() => (
    <BOHTable isLoading={isLoading}>
      <BOHTHead>
        <BOHTR>
          <BOHTH2 width={InitialWidths[0]}>{'Area'}</BOHTH2>
          <BOHTH2 width={InitialWidths[1]}>{'Belongs To'}</BOHTH2>
          <BOHTH2 width={InitialWidths[2]}>{'Delivery Charge'}</BOHTH2>
          <BOHTH2 width={InitialWidths[3]}>{'Pickup Charges'}</BOHTH2>
          <BOHTH2 width={InitialWidths[4]}>{'Actions'}</BOHTH2>
        </BOHTR>
      </BOHTHead>
      <BOHTBody>
        {renderTableData}
      </BOHTBody>
    </BOHTable>
  ), [isLoading, tableData]);

  return (
    <BasicLayout navigation={navigation} goBack={goBack} screenName={'Up Charges'}>
      <CommonContainer>
        <View style={styles.filterContainer}>
          <Text style={styles.filterLabel}>Filter by Belongs To:</Text>
          <Picker
            style={styles.picker}
            selectedValue={filterBelongsTo}
            onValueChange={(val) => {
              setFilterBelongsTo(val);
              setUpdateTrigger(true);
            }}
          >
            <Picker.Item label="All" value="" />
            <Picker.Item label="Charleston" value="charleston" />
            <Picker.Item label="Hilton Head" value="hiltonhead" />
          </Picker>
        </View>
        {tableElement}
        <AddDeliveryChargeModal
          isModalVisible={isModalVisible}
          details={selectedArea}
          setUpdateDeliveryChargeTrigger={setUpdateTrigger}
          closeModal={closeModal}
        />
      </CommonContainer>
    </BasicLayout>
  );
};

const styles = StyleSheet.create({
  filterContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
    paddingHorizontal: 10,
  },
  filterLabel: {
    fontSize: 14,
    fontWeight: '600',
    marginRight: 10,
  },
  picker: {
    height: 50,
    width: 200,
  },
});

export default DeliveryCharges;
